module.exports = __webpack_public_path__ + "img/6.df44b950.svg";